import request from '@/axios'
import type { UserLoginType, UserType } from './types'

// 管理员登录
export const loginApi = (data: UserLoginType): Promise<IResponse<UserType>> => {
  return request.post({ url: '/api/admin/auth/login', data })
}

// 刷新 Admin Token
export const refreshTokenApi = (refreshToken: string): Promise<IResponse<any>> => {
  return request.post({ url: '/api/admin/auth/refresh', params: { refreshToken } })
}

// 退出（前端清除 token 即可）
export const loginOutApi = (): Promise<IResponse> => {
  return Promise.resolve({ code: 0, data: true, message: 'ok', success: true } as any)
}
